export enum RateTypeEnum {
  FIXED = 'Fixed',
  FLOATING = 'Floating',
  FIXED_FLOATING = 'Fixed or Floating',
}
